//WebViewManager for traditional browsers. It navigates the current window to the new route.
angular.module('aprima-legacy-common').factory('BrowserWebViewManager', ['$window', '$state',
    function ($window, $state) {
        'use strict';

        function activateView(appRoute, transition) {
            var opts = transition.opts;
            if(opts.replaceCurrentState && opts.replaceCurrentState === true){
                $state.go(appRoute.state, opts, {location: 'replace'});
            }
            else{
                $state.go(appRoute.state, opts);
            }
            return true;
        }

        function goBack(){
            $window.history.back();
        }

        return {
            activateView: activateView,
            goBack : goBack
        };
    }]);
